import MyClientCompany from "../components/MyClientCompany";
import ClientFiles from "../components/ClientFiles";
import { Box, Container } from "@mui/material";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useRoleLayout } from "../hooks/useRoleLayout";

const ClientCompanies = () => {
  const { role, Layout } = useRoleLayout();
  const selectedCompanyId = useSelector((state) => state.kyc.selectedCompanyId);

  const activeClient = useSelector((state) => state.client?.activeClient);
  const selectedClient = useSelector((state) => state.client?.selectedClient);

  useEffect(() => {
    console.log("Selected company changed:", selectedCompanyId);
  }, [selectedCompanyId]);

  useEffect(() => {
    console.log("Client changed:", activeClient || selectedClient);
  }, [activeClient, selectedClient]);

  return (
    <>
      <Layout>
        <Container maxWidth="xl" sx={{ mt: 4, mb: 6 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <Box sx={{ width: "100%" }}>
              <MyClientCompany />
            </Box>

            <Box sx={{ width: "100%" }}>
              <ClientFiles />
            </Box>
          </Box>
        </Container>
      </Layout>
    </>
  );
};

export default ClientCompanies;
